export const isCutOffPoint = (stackTrace: string): boolean => {
    return stackTraceCutOffPoint.some(cutOffPoint => stackTrace.includes(cutOffPoint))
}

const stackTraceCutOffPoint = [
    'Doctrine\\DBAL\\Connection::executeQuery',
    'Doctrine\\DBAL\\Connection::executeUpdate',
    'Doctrine\\DBAL\\Connection::fetchAllAssociative',
    'Doctrine\\DBAL\\Connection::fetchOne',
    'Doctrine\\DBAL\\Query\\QueryBuilder::executeQuery',
    'Doctrine\\DBAL\\Statement::execute',
    'Doctrine\\DBAL\\Statement::executeStatement',
    'Doctrine\\DBAL\\Statement::executeQuery',
    'Doctrine\\ORM\\EntityManager::find',
    'Doctrine\\ORM\\EntityManager::flush',
    'Doctrine\\ORM\\EntityRepository::findBy',
    'Doctrine\\ORM\\EntityRepository::findOneBy',
    'Doctrine\\ORM\\AbstractQuery::getResult',
    'Doctrine\\ORM\\AbstractQuery::getScalarResult',
    'Doctrine\\ORM\\AbstractQuery::execute',
    'GuzzleHttp\\Client::send',
    'GuzzleHttp\\Client::sendRequest',
    'GuzzleHttp\\Client::sendAsync',
    'GuzzleHttp\\Client::request',
    'GuzzleHttp\\Client::requestAsync',
    'GuzzleHttp\\Client::transfer',
    'Illuminate\\Database\\Connection::run',
    'Illuminate\\Database\\Connection::runQueryCallback',
    'Illuminate\\Database\\Connection::statement',
    'Illuminate\\Database\\Query\\Builder::get',
    'Illuminate\\Database\\Query\\Builder::runSelect',
    'Magento\\Framework\\Data\\Collection\\AbstractDb::getData',
    'Magento\\Framework\\DB\\Adapter\\Pdo\\Mysql::query',
    'Magento\\Eav\\Model\\Entity\\Collection\\AbstractCollection::load',
    'OpenSearch\\Client::performRequest',
    'oxLegacyDb::execute',
    'oxLegacyDb::getAll',
    'oxLegacyDb::getOne',
    'oxLegacyDb::select',
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Dbal\\EntityReader::read',
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Doctrine\\RetryableQuery::execute',
    'Symfony\\Component\\HttpClient\\Response\\CurlResponse::getContent',
    'Symfony\\Component\\HttpClient\\Response\\CurlResponse::getHeaders',
    'Symfony\\Component\\HttpClient\\Response\\CurlResponse::initialize',
    'WP_Http::request',
    'wpdb::get_results',
    'wpdb::query',
    'Zend_Db_Adapter_Abstract::fetchAll',
    'Zend_Db_Adapter_Abstract::fetchOne',
    'Zend_Db_Adapter_Abstract::query',
    'Zend_Db_Adapter_Pdo_Abstract::query',
]
